import {
  FibuAccountNonStationarySchema,
  FibuAccountStationarySchema,
  IFibuAccountNonStationary,
  IFibuAccountStationary,
} from '@dokucoach/common-types';
import { values } from 'lodash';
import * as yup from 'yup';
import { FibuExportType } from '../../enums';

export const FibuSchema = yup.object({
  exportType: yup.mixed<FibuExportType>().oneOf(values(FibuExportType)).required(),
  datevClientNumber: yup.string().notRequired(),
  datevConsultantNumber: yup.string().notRequired(),
  accountStationary: FibuAccountStationarySchema.required(),
  accountNonStationary: FibuAccountNonStationarySchema.required(),
});

export interface IFibu {
  exportType: FibuExportType;
  datevClientNumber?: string | null;
  datevConsultantNumber?: string | null;
  accountStationary: IFibuAccountStationary;
  accountNonStationary: IFibuAccountNonStationary;
}
